export { default } from './LazyCourses';
